// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Z22W","productName":"Table_productName__3eaco"};